import get from 'lodash.get';

import {
    VirtualizedTableColumns,
    VirtualizedTableItem
} from 'services/virtualizedTable/types';
import { ActiveIngredient } from 'services/activeIngredients/types';
import { selectActiveActiveIngredients } from 'services/activeIngredients/selectors';
import { selectIsAdmin, selectIsManager } from 'services/usersMe/selectors';
import { FIELD_TYPE_STRING } from 'components/VirtualizedTable/constants';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentSeasonIsComplete } from 'services/currentSeasonId/selectors';

const selectActiveIngredientsTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths()],
    (tableColumnWidths): VirtualizedTableColumns => {
        const result: VirtualizedTableColumns = [
            {
                label: 'Name',
                value: 'name',
                width: 250,
                type: FIELD_TYPE_STRING,
                validators: 'isRequired'
            },
            {
                label: 'Reference',
                value: 'externalId',
                width: 150,
                type: FIELD_TYPE_STRING,
                validators: 'isRequired'
            }
        ];

        return result.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

const selectActiveIngredientItems = createDeepEqualSelector(
    [selectActiveActiveIngredients],
    (activeIngredients) =>
        activeIngredients.map(
            (activeIngredient: ActiveIngredient): VirtualizedTableItem => {
                const { uuid, id, name, externalId } = activeIngredient;
                return {
                    key: uuid,
                    id,
                    name,
                    externalId
                };
            }
        )
);

const makeSelectActiveIngredientItems = (): typeof selectActiveIngredientItems =>
    selectActiveIngredientItems;

const selectIsWritable = createDeepEqualSelector(
    [selectIsAdmin, selectIsManager, selectCurrentSeasonIsComplete],
    (isAdmin: boolean, isManager: boolean, currentSeasonIsComplete): boolean =>
        (isAdmin || isManager) && !currentSeasonIsComplete
);

export {
    selectActiveIngredientsTableColumns,
    makeSelectActiveIngredientItems,
    selectIsWritable
};
